export const TRIP_TYPE_ONE_WAY = "One Way";
export const TRIP_TYPE_RETURN_TRIP = "Return Trip";
export const TRIP_TYPE_MULTI_LEG = "Multi-Leg";

/**
 * Trip type label from leg count (quote header, summaries, contract, etc.).
 * @param {number} legsLength
 * @returns {string|null}
 */
export const getTripTypeLabelFromLegCount = (legsLength) => {
    if (legsLength == null || legsLength < 1) return null;
    if (legsLength === 1) return TRIP_TYPE_ONE_WAY;
    if (legsLength === 2) return TRIP_TYPE_RETURN_TRIP;
    return TRIP_TYPE_MULTI_LEG;
};

/**
 * Normalises API or legacy labels (e.g. "Return Trip Type") for display.
 * @param {string|null|undefined} value
 * @returns {string}
 */
export const normalizeTripTypeDisplay = (value) => {
    if (value == null) return "";
    const s = String(value).trim();
    if (!s) return "";
    if (/return\s+trip\s+type/i.test(s)) return TRIP_TYPE_RETURN_TRIP;
    if (/^return$/i.test(s)) return TRIP_TYPE_RETURN_TRIP;
    return s;
};
